import svgPaths from './svg-kg3ujvxt0w';

export default function Vector() {
  return (
    <div className="relative size-full" data-name="Vector">
      <svg className="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 250 44.8435">
        <g id="Vector">
          <path d={svgPaths.p3df4e000} fill="#F1B041" />
          <path d={svgPaths.p250d6300} fill="#F1B041" />
          <path d={svgPaths.p3023e300} fill="var(--fill-0, #1A1A1A)" />
          <path d={svgPaths.p3840ff00} fill="var(--fill-0, #1A1A1A)" />
          <path d={svgPaths.p24b6c600} fill="var(--fill-0, #1A1A1A)" />
          <path d={svgPaths.p134b2280} fill="var(--fill-0, #1A1A1A)" />
        </g>
      </svg>
    </div>
  );
}
